import _ from 'lodash';

export const supportDocsCount = 3;
export const testReportsCount = 5;

export const fillDocsArray = (amount = supportDocsCount) => {
  let slotCounter = 0;
  return Array.apply(undefined, Array(amount)).map(() => {
    slotCounter++;
    return {
      file: null,
      title: '',
      slot: slotCounter
    };
  });
};

export const fillUploadedDocsArray = (
  amount = supportDocsCount,
  docArray = []
) => {
  const sortedArr = _.mapKeys(docArray, 'slot');
  let slotCounter = 0;
  return Array.apply(undefined, Array(amount)).map(() => {
    slotCounter++;

    const doc = _.isUndefined(sortedArr[slotCounter])
      ? null
      : sortedArr[slotCounter];

    return {
      file: null,
      title: doc ? doc.document.title : '',
      slot: doc ? doc.slot : slotCounter,
      docId: doc ? doc.documentid : 0,
      ...doc
    };
  });
};

export const getUploadQueue = docList => {
  return _.filter(docList, doc => {
    const title = String(doc.title);
    return doc.file !== null && title.length > 0;
  });
};

export const hasDocsForUpload = docList => {
  return getUploadQueue(docList).length > 0;
};

export const getUploadedTitlesQueue = docList => {
  return _.filter(docList, doc => {
    const title = String(doc.title);
    return doc.id > 0 && title.length > 0;
  });
};

export const hasTitlesForChange = docList => {
  return getUploadedTitlesQueue(docList).length > 0;
};

export const downloadFile = (fileData, fileName) => {
  const blob = new Blob([fileData]);

  // IE11 doesn't work with Blob on the fly
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  }
};

export const fillReportsArray = (amount = testReportsCount) => {
  let slotCounter = 0;
  return Array.apply(undefined, Array(amount)).map(() => {
    slotCounter++;
    return {
      status: 0,
      title: '',
      file: null,
      slot: slotCounter
    };
  });
};

export const hasPendingUploads = uploads => {
  return _.some(uploads, 'pending');
};

export const hasResponseFailed = response => {
  return !_.isUndefined(response) && _.includes([415, 500], response.status);
};

export const getResponseError = response => {
  if (response && response.status !== 201) {
    return response.statusText;
  }
  return null;
};

export const manageQueue = (
  options,
  uploadHandler,
  addHandler,
  removeHandler
) => {
  const { slot, title } = options;

  // add uploading request to queue
  addHandler({ slot, title });

  // remove uploaded slot from queue
  const queueCallback = res => {
    const error = hasResponseFailed(res.payload.response);
    const errorMessage = getResponseError(res.payload.response);
    removeHandler({ slot, title, error, errorMessage });
  };

  // upload, after remove uploaded slot from queue
  uploadHandler(options).then(queueCallback);
};

export const prepareUsersManualOptions = (usersManual, modelId) => {
  return {
    modelId,
    slot: 0,
    title: 'Product Description',
    fileContent: usersManual.file
  };
};

export const prepareSupDocOptions = (
  slot,
  title,
  fileContent,
  requestId,
  sendEmail
) => {
  return {
    slot,
    title,
    requestId,
    fileContent,
    sendEmail
  };
};

export const prepareTestReportOptions = (slot, title, fileContent, testId) => {
  return {
    slot,
    title,
    testId,
    fileContent
  };
};



// WEBPACK FOOTER //
// ./src/helpers/Uploads.js